var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFilled = function SvgUserFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4C25.9778 4 27.9112 4.58649 29.5557 5.6853C31.2002 6.78412 32.4819 8.3459 33.2388 10.1732C33.9957 12.0004 34.1937 14.0111 33.8079 15.9509C33.422 17.8907 32.4696 19.6725 31.0711 21.0711C29.6725 22.4696 27.8907 23.422 25.9509 23.8079C24.0111 24.1937 22.0004 23.9957 20.1732 23.2388C18.3459 22.4819 16.7841 21.2002 15.6853 19.5557C14.5865 17.9112 14 15.9778 14 14L14.01 13.566C14.1218 10.9915 15.2232 8.55956 17.0844 6.77732C18.9457 4.99508 21.4231 4.00015 24 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 28C30.6522 28 33.1957 29.0536 35.0711 30.9289C36.9464 32.8043 38 35.3478 38 38V40C38 41.0609 37.5786 42.0783 36.8284 42.8284C36.0783 43.5786 35.0609 44 34 44H14C12.9391 44 11.9217 43.5786 11.1716 42.8284C10.4214 42.0783 10 41.0609 10 40V38C10 35.3478 11.0536 32.8043 12.9289 30.9289C14.8043 29.0536 17.3478 28 20 28H28Z",
    fill: "currentColor"
  })))));
};
export default SvgUserFilled;